import { render, staticRenderFns } from "./fluxPoll.vue?vue&type=template&id=2ef61c23&"
import script from "./fluxPoll.vue?vue&type=script&lang=js&"
export * from "./fluxPoll.vue?vue&type=script&lang=js&"
import style0 from "./fluxPoll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports